// ============================================
// BROUILLON DE RÉPONSE — par dossier, le temps de la session
// ============================================
// Le texte en cours survit au changement d'onglet de la fiche et à une
// fermeture accidentelle. Le mode (note interne ou message au client) est
// gardé avec le texte : une note ne doit jamais revenir en message public.
// sessionStorage peut être indisponible (navigation privée, stockage
// bloqué) : chaque accès est protégé, et une copie en mémoire couvre au
// moins le changement d'onglet.

export interface Brouillon {
  texte: string;
  interne: boolean;
}

const cle = (ticketId: string) => `kly_admin_brouillon_${ticketId}`;
const memoire = new Map<string, Brouillon>();

export function lireBrouillon(ticketId: string): Brouillon | null {
  try {
    const brut = window.sessionStorage.getItem(cle(ticketId));
    if (brut) {
      const v = JSON.parse(brut) as Partial<Brouillon>;
      if (typeof v.texte === 'string') return { texte: v.texte, interne: v.interne === true };
    }
  } catch {
    /* stockage indisponible ou contenu illisible : on se rabat sur la mémoire */
  }
  return memoire.get(ticketId) ?? null;
}

export function ecrireBrouillon(ticketId: string, brouillon: Brouillon): void {
  if (!brouillon.texte) {
    effacerBrouillon(ticketId);
    return;
  }
  memoire.set(ticketId, { ...brouillon });
  try {
    window.sessionStorage.setItem(cle(ticketId), JSON.stringify(brouillon));
  } catch {
    /* stockage indisponible : la copie en mémoire suffit pour la session */
  }
}

export function effacerBrouillon(ticketId: string): void {
  memoire.delete(ticketId);
  try {
    window.sessionStorage.removeItem(cle(ticketId));
  } catch {
    /* rien à faire */
  }
}
